import Carousel       from 'react-multi-carousel';
import carouselStyles from 'react-multi-carousel/lib/styles.css?inline';


import ResponsiveDirectusImage from './ResponsiveImage.jsx';
import { findAssetByTitle }    from '../helpers.js';
import ChevronRight            from './icons/ChevronRight.jsx';
import Link                    from './Link.jsx';

const CustomArrow = ({ onClick, side, classNames }) => {
  return <button
    aria-label={`${side === 'right' ? 'Next Slide' : 'Previous Slide'}`} onClick={() => onClick()}
    class={`h-[40px] w-[40px] flex items-center justify-center rounded-full bg-darkGray/50 hover:bg-darkGray/30 z-40 ${side === 'right' ? 'right-0' : 'left-0'} ${classNames}`}>
    <ChevronRight class={`${side === 'right' ? 'rotate-0' : 'rotate-180'} fill-white`} height="12px" width="12px"/>
  </button>;
};

const CustomDot = ({ onClick, ...rest }) => {
  const { active, index, slides, carouselState } = rest;
  const dotBaseColor = 'bg-gray';

  return <li class="px-[6px]">
    <button aria-label={`Slide ${index}`} onClick={onClick}
            class={`transition duration-300 ease-in-out rounded-md ${active ? 'w-[50px] bg-green' : `w-[20px] ${dotBaseColor}`}`}>
      <div class="h-[4px]"/>
    </button>
  </li>
}

const CustomButtonGroup = ({ next, previous, ...rest }) => {
  const { carouselState: { currentSlide, slidesToShow, totalItems } } = rest;
  const pages = Math.ceil(totalItems / slidesToShow);
  const currentPage = Math.floor(currentSlide / slidesToShow) + 1;
  // Todo hide next arrow when out of pages
  return (
    <div class="absolute z-10 w-full justify-between h-[40px] left-0 right-0 top-[50%] sm:hidden md:flex lg:flex">
      <div class="sm:w-[7%] md:w-[8%] lg:w-[8%] h-[40px] flex justify-center">
        {currentSlide !== 0 && <CustomArrow side={'left'} onClick={previous}/>}
      </div>
      <div class="sm:w-[7%] md:w-[8%] lg:w-[8%] h-[40px] flex justify-center">
        <CustomArrow side={'right'} onClick={next}/>
      </div>
    </div>
  )
};

const KeepExploring = ({ elements, assets, fullLengthsSlide = false }) => {
  const responsive = {
    lg: {
      breakpoint: { max: 3000, min: 1025 },
      items: 4,
      slidesToSlide: fullLengthsSlide ? 4 : 1,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
      slidesToSlide: fullLengthsSlide ? 3 : 1,
    },
    sm: {
      breakpoint: { max: 767, min: 0 },
      items: 2,
      slidesToSlide: fullLengthsSlide ? 2 : 1,
    }
  };
  return (
    <>
      <style type="text/css">{carouselStyles}</style>
      <div class="relative">
        <h2 class="headline-36 sm:px-[7%] md:px-[8%] lg:px-[8%]">Weiterlesen</h2>
        <nav class="sm:px-[7%] md:px-[8%] lg:px-[8%]">
          <Carousel responsive={responsive}
                    showDots
                    renderDotsOutside
                    renderButtonGroupOutside
                    customButtonGroup={<CustomButtonGroup/>}
                    customDot={<CustomDot slides={elements}/>}
                    arrows={false}
                    dotListClass="!bottom-[-40px]"
                    sliderClass="z-20"
          >
            {elements.map(element => {
              let asset;
              if (assets) {
                asset = findAssetByTitle(element.image, assets).rlx_responsive_asset_id;
              } else {
                asset = element.image
              }
              return (
                <Link activeClassName="!text-green" href={element.link_to} class="group relative overflow-hidden block px-[4px]">
                  <div class="relative overflow-hidden">
                    <ResponsiveDirectusImage imgClass="group-hover:scale-110 transition-transform duration-700 ease-out"
                                             assetLandscape={asset.asset_landscape} assetPortrait={asset.asset_portrait}
                                             alt={element.heading}/>
                  </div>
                  <p class="body-20 !font-bold pe-[20px] pt-[10px]">{element.heading}</p>
                </Link>
              )
            })}
          </Carousel>
        </nav>
      </div>
    </>
  )
};

export default KeepExploring;
